import { render, staticRenderFns } from "./Carregamento.vue?vue&type=template&id=3018b4b2&"
import script from "./Carregamento.vue?vue&type=script&lang=js&"
export * from "./Carregamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports